import { store, store$ } from '@redux/store';
import { distinctUntilChanged, map } from 'rxjs';
import { selectLuxury, selectProductAndResultType } from '../redux/selectors';
import getDefaultProductType from '../services/productTypeService';
import getDefaultResultType from '../services/resultTypeService';
import { searchParametersSlice } from '../redux/slices';

export default class LuxuryHousingType {
  constructor() {
    this.selector = '[data-housing-type="luxury"]';
    store$.pipe(map(selectLuxury), distinctUntilChanged()).subscribe(this.onLuxuryChange.bind(this));

    store$.pipe(map(selectProductAndResultType), distinctUntilChanged())
      .subscribe(this.onProductAndResultTypeChange.bind(this));
  }

  /**
   * The dispatchAction function dispatches a fetchLuxury action with the payload obtained from the
   * getSearchCommands function.
   */
  dispatchFetchResultAction() {
    const payload = this.getSearchCommands();
    store.dispatch(searchParametersSlice.actions.fetchLuxury(payload));
  }

  /**
   * Gets the node element of luxury box.
   * @returns {Node} element.
   */
  getNode() {
    return document.querySelector(this.selector);
  }

  /**
   * getSearchCommands: Gets the search command property of this Housing Box.
   * @returns The search command property string.
   */
  getSearchCommands() {
    const searchCommandPropertyStructure = {
      productType: this.productTypeToApply,
      resultType: this.resultTypeToApply,
      luxury: this.luxuryToApply,
    };

    return searchCommandPropertyStructure;
  }

  /**
   * The function updates the product and result type to apply based on the selected product and result type.
   * @param productAndResultType - It represents the object with the product and result type.
   */
  onProductAndResultTypeChange(productAndResultType) {
    const { resultType, productType} = productAndResultType;
    this.productTypeToApply = getDefaultProductType(productType, resultType);
    this.resultTypeToApply = getDefaultResultType(resultType);
  }

  /**
   * The function "onLuxuryChange" sets the "luxury" property to the provided value (or false if no
   * value is provided) and then calls the "toggleBox" function.
   * @param luxury - The "luxury" parameter is a boolean value that determines whether the luxury
   * feature should be enabled or disabled.
   */
  onLuxuryChange(luxury) {
    this.luxuryToApply = !luxury;
    this.toggleBox(luxury);
  }

  /**
   * The toggleBox function adds or removes the 'active' class from a node based on the value of the
   * 'luxury' property.
   */
  toggleBox(luxury) {
    const node = this.getNode();
    if (luxury) {
      node.selected = true;
    } else {
      node.selected = false;
    }
  }
}
